import { defineComponent as _defineComponent } from 'vue'
import {
  alternatives,
  criterions,
  stakeholders,
  getCriterionName,
  getAlternativeName,
  getItemsBy,
  getRangeColorClass,
  getWeightedAcceptability,
  getFilteredAimsBy,
} from "@/store";
import { orderBy } from "lodash";
import { computed, PropType, toRefs } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TableChartOne',
  props: {
  selectedAlternative: {
    type: Number,
  },
  selectedType: {
    type: String as PropType<"stakeholder" | "criterion">,
  },
  selectedCriterion: {
    type: Number,
  },
  selectedAim: {
    type: Number,
  },
  selectedStakeholder: {
    type: Number,
  },
  filteredAims: {
    type: Array as PropType<ReturnType<typeof getFilteredAimsBy>>,
  },
},
  setup(__props) {

const props = __props



const {
  selectedCriterion,
  selectedType,
  selectedAlternative,
  selectedStakeholder,
  selectedAim,
  filteredAims,
} = toRefs(props);

const typeColumnName = computed(() => {
  if (selectedType.value === "criterion" && selectedCriterion.value !== null) {
    return "Aims";
  }
  if (selectedType.value === "criterion" && selectedCriterion.value === null) {
    return "Criteria";
  }
  if (selectedType.value === "stakeholder") {
    return "Stakeholders";
  }
  return null;
});

const titleColumnName = computed(() => {
  if (selectedType.value === "criterion" && selectedCriterion.value !== null) {
    return `${getAlternativeName(
      selectedAlternative.value
    )} : ${getCriterionName(selectedCriterion.value)}`;
  }
  if (selectedType.value === "criterion" && selectedCriterion.value === null) {
    return getAlternativeName(selectedAlternative.value);
  }
  if (selectedType.value === "stakeholder") {
    return getAlternativeName(selectedAlternative.value);
  }
  return null;
});

const getCriterionRows = () => {
  return criterions.value.map(({ name, id }) => {
    const favorableItems = getItemsBy({
      alternative: selectedAlternative.value,
      criterion: id,
      favorable: true,
    });
    const unfavorableItems = getItemsBy({
      alternative: selectedAlternative.value,
      criterion: id,
      favorable: false,
    });

    const acceptability = getWeightedAcceptability([
      ...favorableItems,
      ...unfavorableItems,
    ])[selectedAlternative.value];
    return {
      name,
      id,
      favorableItems,
      unfavorableItems,
      acceptability,
    };
  });
};

const getCriterionAimsRows = () => {
  return filteredAims.value.map(({ name, id }) => {
    const favorableItems = getItemsBy({
      alternative: selectedAlternative.value,
      criterion: selectedCriterion.value,
      aim: id,
      favorable: true,
    });
    const unfavorableItems = getItemsBy({
      alternative: selectedAlternative.value,
      criterion: selectedCriterion.value!,
      aim: id,
      favorable: false,
    });

    const acceptability = getWeightedAcceptability([
      ...favorableItems,
      ...unfavorableItems,
    ])[selectedAlternative.value];

    return {
      name,
      id,
      favorableItems,
      unfavorableItems,
      acceptability,
    };
  });
};

const getStakholderRows = () => {
  return stakeholders.value.map(({ name, id }) => {
    const favorableItems = getItemsBy({
      alternative: selectedAlternative.value,
      stakeholder: id,
      favorable: true,
    });
    const unfavorableItems = getItemsBy({
      alternative: selectedAlternative.value,
      stakeholder: id,
      favorable: false,
    });

    const acceptability = getWeightedAcceptability([
      ...favorableItems,
      ...unfavorableItems,
    ])[selectedAlternative.value];
    return {
      name,
      id,
      favorableItems,
      unfavorableItems,
      acceptability,
    };
  });
};

const getStakeholderAimsRows = () => {
  return stakeholders.value.map(({ name, id }) => {
    const favorableItems = getItemsBy({
      alternative: selectedAlternative.value,
      stakeholder: selectedStakeholder.value!,
      aim: id,
      favorable: true,
    });
    const unfavorableItems = getItemsBy({
      alternative: selectedAlternative.value,
      stakeholder: selectedStakeholder.value!,
      aim: id,
      favorable: false,
    });

    const acceptability = getWeightedAcceptability([
      ...favorableItems,
      ...unfavorableItems,
    ])[selectedAlternative.value];

    return {
      name,
      id,
      favorableItems,
      unfavorableItems,
      acceptability,
    };
  });
};

const rows = computed(() => {
  const _rows = () => {
    if (selectedType.value === "criterion") {
      if (selectedCriterion.value === null) {
        return getCriterionRows();
      } else {
        return getCriterionAimsRows();
      }
    } else if (selectedType.value === "stakeholder") {
      if (selectedStakeholder.value === null) {
        return getStakholderRows();
      } else {
        return getStakeholderAimsRows();
      }
    } else {
      return [];
    }
  };
  const sortedRows = orderBy(
    _rows(),
    ({ acceptability }) => acceptability || "",
    ["desc"]
  );
  console.log(sortedRows.map((x) => x.acceptability));
  return sortedRows;
});

const itemsToCompare = computed(() => {
  return alternatives.value.reduce((acc, { id: alternativeId }) => {
    const criterionItems = Object.keys(criterions.value).reduce(
      (acc, criterionId) => {
        const favorableItems = [true, false].reduce((acc, value) => {
          const items = getItemsBy({
            alternative: Number(alternativeId),
            criterion: Number(criterionId),
            favorable: value,
          });

          return [...acc, items];
        }, []);

        return [...acc, ...favorableItems];
      },
      []
    );

    return [...acc, ...criterionItems];
  }, []);
});

const maxLengthItem = computed(() =>
  Math.max(...[...itemsToCompare.value].map((group: any) => group.length))
);

const getPercentageByMaxLength = (value: number) => {
  return (value * 100) / maxLengthItem.value;
};

return { __sfc: true,props, selectedCriterion, selectedType, selectedAlternative, selectedStakeholder, selectedAim, filteredAims, typeColumnName, titleColumnName, getCriterionRows, getCriterionAimsRows, getStakholderRows, getStakeholderAimsRows, rows, itemsToCompare, maxLengthItem, getPercentageByMaxLength, getRangeColorClass }
}

})